import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo, type ReactNode } from "react";
import { useAuth } from "react-oidc-context";
import { useMe } from "../../lib/useApi";
import { MailScopeContext } from "./mailScope";

/** 本人・access token・ロール変更で local state も query cache も捨てる。 */
export function MailSession({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const me = useMe();
  const qc = useQueryClient();
  const token = auth.user?.access_token;
  const principal = useMemo(() => ({ token, key: crypto.randomUUID() }), [token]);
  const roles = JSON.stringify([me.data?.sub, me.data?.email, me.data?.roles, me.data?.is_suite_admin]);
  useEffect(() => () => {
    void qc.cancelQueries({ queryKey: ["dlp", "mail"] });
    qc.removeQueries({ queryKey: ["dlp", "mail"] });
  }, [qc, principal, roles]);
  if (!auth.isAuthenticated || me.isFetching || me.isError) return null;
  return <MailScopeContext.Provider key={principal.key + roles} value={principal.key + roles}>{children}</MailScopeContext.Provider>;
}
